import moment from 'moment'
import React, { useState } from 'react'
import {
  IconEditSvg,
  IconTrashSvg,
  SessionSvg
} from '../../../assets/icons/svgComponents'
import * as S from '../style'
import 'moment/locale/pt-br'
import theme from '../../../styles/theme'
import { SessionModel } from '../../../../domain/models/session'
import { CustomerModel, ServiceModelDto } from '../../../../domain/models'
import DeleteSessionModal from '../../accordion-table/delete-session'
import SessionForm from '../modal/session'
import { useModalBox } from '../../../contexts'

type PageProps = {
  session: SessionModel
  patient: CustomerModel | undefined
  service: ServiceModelDto
}
const SessionCard = ({ session, patient, service }: PageProps): JSX.Element => {
  const [openActions, setOpenActions] = useState<boolean>(false)
  const { modalBox } = useModalBox()
  const handleOpenDeleteServiceModal = () => {
    modalBox(<DeleteSessionModal item={session} />, 'Deletar Sessão', '35%')
  }

  const handleOpenSessionModal = () => {
    if (session) {
      modalBox(
        <SessionForm
          cdServiceProps={Number(service.cdServico)}
          session={session}
        />,
        'Validação de dados',
        '46%'
      )
    }
  }
  return (
    <S.ContainerCard color={theme.colors.primary}>
      <S.IconTop color={theme.colors.primary}>
        <SessionSvg outlined />
      </S.IconTop>
      <S.Title>
        {session.titulo}
        <S.Options
          onClick={() => {
            setOpenActions((prev) => !prev)
          }}
        >
          {openActions && (
            <S.DropdownAction>
              <span>
                <S.ActionButtonCard onClick={() => handleOpenSessionModal()}>
                  <IconEditSvg /> Editar
                </S.ActionButtonCard>
                <S.ActionButtonCardCancel
                  onClick={() => handleOpenDeleteServiceModal()}
                >
                  <IconTrashSvg /> Excluir
                </S.ActionButtonCardCancel>
              </span>
            </S.DropdownAction>
          )}
          ...
        </S.Options>
      </S.Title>
      <S.SubTitle>
        {moment(`${new Date(session?.dataInicio || '')}`)
          .locale('pt-br')
          .format('DD [de] MMMM [de] YYYY')}
      </S.SubTitle>
      <S.Paragraph
        onClick={() => {
          setOpenActions((prev) => !prev)
        }}
      >
        <span>{session.resumo}</span>
        <S.SeeMore
          to={`/meus-pacientes/${patient?.cdCliente}/${service.cdServico}/sessao/${session.cdSessao}`}
        >
          Ver mais
        </S.SeeMore>
      </S.Paragraph>
    </S.ContainerCard>
  )
}
export default SessionCard
